import React from 'react';
import HGProfile from 'components/HGProfile';
import FirmwareSideload from 'components/DeviceDetails/FirmwareSideload';
import {
    ChevronRight,
    ChevronLeft,
    ChevronDown,
    ChevronUp,
} from 'lucide-react';
import { useProfileData } from 'components/HGProfile/helper';

const DeviceProfileTab = ({ showSideload }) => {
    const [firmwareOpen, setFirmwareOpen] = React.useState(false);
    const { loading: profileLoading } = useProfileData();
    const showSideloadButton = showSideload && !profileLoading;

    return (
        <div className="relative flex flex-col lg:flex-row lg:items-stretch">
            <div className="relative min-w-0 flex-1">
                <HGProfile />
                {/* Desktop: fixed to right-center edge of HGProfile */}
                {showSideloadButton && (
                    <button
                        onClick={() => setFirmwareOpen(!firmwareOpen)}
                        className="absolute right-0 top-1/2 z-10 mr-5 hidden -translate-y-1/2 translate-x-1/2 rounded border border-border bg-card p-2 shadow-md transition-colors hover:bg-muted lg:block"
                        title="Push Firmware"
                    >
                        {firmwareOpen ? (
                            <ChevronRight className="h-5 w-5 text-gray-600 dark:text-slate-300" />
                        ) : (
                            <ChevronLeft className="h-5 w-5 text-gray-600 dark:text-slate-300" />
                        )}
                    </button>
                )}
            </div>
            <div
                className={`mt-8 overflow-hidden transition-[max-height] duration-300 ease-in-out lg:mt-0 lg:max-h-none lg:transition-[width] ${firmwareOpen && showSideload ? 'max-h-[500px] lg:w-80' : 'max-h-0 lg:w-0'}`}
            >
                <FirmwareSideload />
            </div>
            {/* Mobile: tracks bottom of outer container as it expands */}
            {showSideloadButton && (
                <button
                    onClick={() => setFirmwareOpen(!firmwareOpen)}
                    className="absolute -bottom-3 left-1/2 z-10 -translate-x-1/2 rounded-full border border-border bg-card p-2 shadow-md transition-colors hover:bg-muted lg:hidden"
                    title="Push Firmware"
                >
                    {firmwareOpen ? (
                        <ChevronUp className="h-5 w-5 text-gray-600 dark:text-slate-300" />
                    ) : (
                        <ChevronDown className="h-5 w-5 text-gray-600 dark:text-slate-300" />
                    )}
                </button>
            )}
        </div>
    );
};

export default DeviceProfileTab;
